<template>
  <div class="project-internal-staff-manage">
    <div class="app-control app-table-control">
      <el-button type="primary" @click="init">同步员工</el-button>
      <el-button @click="batchDel">批量删除</el-button>
      <div class="right-region">
        <el-input placeholder="请输入员工姓名或电话" v-model="search.value" clearable></el-input>
        <el-button type="primary" @click="searchParams">搜索</el-button>
        <el-button @click="resetParams">重置</el-button>
      </div>
    </div>
    <el-table :data="datas" v-loading="loading" @selection-change="handleSelectionChange">
      <el-table-column type="selection"></el-table-column>
      <el-table-column label="照片">
        <template slot-scope="{row}">
          <el-image :src="row.face_data.attachment_access_url" :preview-src-list="[row.face_data.attachment_access_url]"></el-image>
        </template>
      </el-table-column>
      <el-table-column label="姓名" prop="attr_data.user_attr_name"></el-table-column>
      <el-table-column label="手机号" prop="attr_data.user_attr_phone"></el-table-column>
      <el-table-column label="部门" prop="attr_data.user_attr_department"></el-table-column>
      <el-table-column label="职位" prop="attr_data.user_attr_title"></el-table-column>
      <el-table-column label="操作">
        <template slot-scope="{row}">
          <el-button type="text" @click="scan(row.user_id)">查看</el-button>
          <el-button type="text" @click="edit(row.user_id)">编辑</el-button>
          <el-button type="text" @click="del(row.user_id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination :total="page.total" :page-size="page.pageSize" :current-page="page.currentPage" @current-change="currentChange" background></el-pagination>
    <el-drawer :title="infoDialog.title" :visible.sync="infoDialog.show" center size="80%" append-to-body>
      <project-staff-information :staffId="infoDialog.id" v-if="infoDialog.show"></project-staff-information>
    </el-drawer>
  </div>
</template>

<script>
  import ProjectService from '@/io/project.js';
  import ProjectStaffInformation from '@/views/ProjectStaffInformation.vue';

  export default {
    name: 'ProjectInternalStaffManage',
    data() {
      return {
        id: this.$route.params.id,
        infoDialog: {
          show: false,
          title: '员工详情',
          id: null
        },
        search: {
          value: ''
        },
        datas: [],
        selectDatas: [],
        loading: false,
        page: {
          pageSize: 0,
          total: 0,
          currentPage: 1
        }
      }
    },
    components: {
      ProjectStaffInformation
    },
    mounted () {
      this.initDatas();
    },
    methods: {
      initDatas() {
        this.loading = true;
        ProjectService.staffListPage(
          this.id,
          this.search.value,
          this.page.currentPage
        ).then(res => {
          let source = res.data;
          if (!source.data.length && this.page.currentPage > 1) {
            this.page.currentPage--;
            this.initDatas();
          } else {
            this.datas = source.data;
            this.page.pageSize = source.per_page;
            this.page.total = source.total;
          }
        }).catch(() => {}).finally(() => {
          this.loading = false;
        });
      },
      init() {
        ProjectService.syncStaff(this.id).then(() => {
          this.$message.success('同步中，稍后请刷新');
        }).catch(() => {});
      },
      handleSelectionChange(val) {
        this.selectDatas = val;
      },
      batchDel() {
        if (this.selectDatas.length) {
          this.$confirm(
            '确认删除?',
            '提示',
            {
              type: 'warning'
            }
          ).then(() => {
            return ProjectService.delStaff(this.id, this.selectDatas.map(val => {
              return val.user_id;
            }));
          }).then(res => {
            return this.initDatas();
          }).then(res => {
            this.$message.success('删除成功');
          }).catch(() => {});
        }
      },
      scan(id) {
        this.infoDialog.show = true;
        this.infoDialog.id = id;
      },
      edit(id) {
        this.$emit('showProjectStaffInfo', id);
      },
      del(id) {
        this.$confirm(
          '确认删除?',
          '提示',
          {
            type: 'warning'
          }
        ).then(() => {
          return ProjectService.delStaff(this.id, [id]);
        }).then(res => {
          return this.initDatas();
        }).then(res => {
          this.$message.success('删除成功');
        }).catch(() => {});
      },
      currentChange(page) {
        this.page.currentPage = page;
        this.initDatas();
      },
      searchParams() {
        this.page.currentPage = 1;
        this.initDatas();
      },
      resetParams() {
        this.search.value = '';
        this.searchParams();
      }
    },
  }
</script>

<style lang="less" scoped>
  @import '../assets/styles/tools.less';
  /deep/ .el-drawer {
    .el-drawer__body {
      background-color: @color-1;
      padding: @distance;
    }
  }
</style>